import React from 'react';
import { connect } from 'react-redux';
import {
    Modal, ModalHeader, ModalBody, ModalFooter,
    Button,Label,FormGroup, Input,InputGroup, InputGroupAddon,Card, CardBlock
} from 'reactstrap';
import { TabContent, TabPane, Nav, NavItem, NavLink,   CardTitle, CardText, Row, Col } from 'reactstrap';
import classnames from 'classnames';

import Spinner from 'react-spinkit';

import swal from 'sweetalert2'
import ReactTable from "react-table";
import "react-table/react-table.css";

import IconSave from 'react-icons/lib/md/save';
import IconEdit from 'react-icons/lib/md/edit';

import * as actions from '../../actions/inventarioFisico';

import Select from 'react-select';

import {api} from '../../actions/_request';
import ModalTablas from '../../components/catalogos/modal_tablas';

const SubmitLoad = () => (
    <div className="p-2">
        <Spinner name="ball-clip-rotate-multiple" color="#b5271f" />
    </div>
);



class InventarioFisicoModal extends React.Component
{
    constructor(props)
    {
        super(props)

        this.state = {
            inventarioFisico: {
                inventario_fisico_id:0,  
                almacen_codigo :'',  
                item_codigo : '',
                item_id : '',
                item_nombre : '',             
                codigo:'',
                almacen:'',
                fisico:'',
                existencia:0,   
                justificacion : '',            
            },
            action: 'save',
            no_editar :false,
            modal:false,
            usuarios:[],
        };

        this.handleInputChange = this.handleInputChange.bind(this);      
        this.handleSubmit = this.handleSubmit.bind(this);      
        this.resetModal= this.resetModal.bind(this);            
        this.handleSelectChange= this.handleSelectChange.bind(this);
        
        this.toggle_modal= this.toggle_modal.bind(this);   
        this.retorno= this.retorno.bind(this);  
        this.ChangeCode= this.ChangeCode.bind(this);
        this.handleClose= this.handleClose.bind(this);
    }
   
    handleSelectChange(select, name) {
        const value = select === null ? null : select.value;
        this.setState({
            impuesto: {
                ...this.state.impuesto,
                [name]: value
            }
        });
    }

    componentDidMount()
    {    
        let prospectoid = this.props.prospectoid;
        let self = this;
              
        if(prospectoid > 0 && prospectoid != self.state.inventarioFisico.inventario_fisico_id)
        {

            api().get(`inventarioFisico/show/${prospectoid}`)
            .then(function(response)
            {
                  
                if(response.status === 200)
                {                
                    self.setState({
                        inventarioFisico: response.data,
                        action: 'update',
                        no_editar:true
                    });

                }

            });
        }
        else if(prospectoid == null && self.state.inventarioFisico.inventario_fisico_id)
        {            
            self.resetModal();
        }
    }

     handleClose (event) {
     
        let {producto} = this.state;
        const target    = event.target;
        const value     = target.type === 'checkbox' ? target.checked : target.value;
        const name      = target.name;
        
        let campo="";
        let tabla=""

        
         switch (name) {
            case "item_codigo":                  
                campo = "item_id";
                tabla="/inventarioalmacen_codigo/"+this.state.inventarioFisico.almacen_id;
                break;
            case "almacen_codigo":                  
	            campo = "almacen_id";
	            tabla="/busqueda_almacen";
	            break;    
        }
        let self =this;
        if(value!=""){
            api().get(`${tabla}/${value}`)
            .then(function(response)
            {                  
                if(response.status === 200)
                { 
                    let vaciar=0;
                     if(Object.keys(response.data).length > 0){
                        
                        let  retorno=response.data;
                        self.retorno(retorno,campo,vaciar,value);
                       
                       
                     }  else{
                         vaciar=1
                         swal("Oops..", "No Existe el Codigo");
                          self.retorno(response.data,campo,vaciar,value);
                     }        
                   
                }

            });
        }else{
            self.retorno([],campo,1,value); 
        }
   }

    ChangeCode(event) {
        let {inventarioFisico} = this.state;
        const target    = event.target;
        let value     = target.type === 'checkbox' ? target.checked : target.value;
        const name      = target.name;
        if(target.type === 'checkbox'){
            value='0';
            if(target.checked)
                value='1';
        }
        inventarioFisico[name]=value;
        
            this.setState({
            	inventarioFisico :inventarioFisico
           });   
    }

    retorno(objeto,campo,vacio=0,valor=""){
       	console.log('renglon---->',objeto);
        let {inventarioFisico} = this.state;
        let self =this;

        switch (campo) {
            case "item_id":
                  inventarioFisico[campo] = objeto.item_id;
                  inventarioFisico.item_nombre=objeto.label?objeto.label:objeto.nombre;
                  inventarioFisico.item_codigo=objeto.codigo_interno;
                  inventarioFisico.costo=objeto.costo;
                  inventarioFisico.existencia=objeto.existencia;
                  break;
            case "almacen_id":
                inventarioFisico[campo] = objeto.value?objeto.value:objeto.id;
                inventarioFisico.almacen_nombre=objeto.label?objeto.label:objeto.nombre;
                inventarioFisico.almacen_codigo= objeto.codigo;
                break;
        }  

       if(vacio==1){
        console.log('vaciar')
        if(campo == 'item_id')
        	inventarioFisico.item_codigo='';
        else{
        	inventarioFisico.almacen_codigo='';
        }
        
        inventarioFisico[campo] =0;

       }
         self.setState({
            inventarioFisico : inventarioFisico,           
            modal:false,         
        })
    }

    toggle_modal(index=0,catalogo="",campo=""){  

        this.setState({
            modal : !this.state.modal,
            titulo:catalogo,
            tabla_modal:index,
            campo_modal:campo,         
        })
    }

    resetModal(){
        this.setState({
            inventarioFisico: {

                id:0,               
                nombre:'',
                telefono:'',
                codigo:'',
                direccion:'',
               usuario_id: parseInt(this.props.auth.user.id),               
            },
            action: 'save',
             activeTab: '1',
        });
        
    }

    handleInputChange(event) {
        let {inventarioFisico} = this.state;
        const target    = event.target;
        const value     = target.type === 'checkbox' ? target.checked : target.value;
        const name      = target.name;

        inventarioFisico[name] = value;
     
        this.setState({
            inventarioFisico : inventarioFisico
        });
    }

    objeto_mayusculas(objeto){
         for (var key in objeto) {
                if (objeto.hasOwnProperty(key)) {
                    // var valor=String(objeto[key]).toUpperCase();                 
                    // console.log('valor---->',valor)
                     
                         objeto[key] = String(objeto[key]).toUpperCase() ;
                         if( String(objeto[key]).toUpperCase()==='NULL')
                            objeto[key] ='';
                     
                    // console.log(key + " = " + objeto[key]);
                }
              }
              return objeto;
    }
   
   

    handleSubmit(evt)
    {
        evt.preventDefault();
        let {inventarioFisico} = this.state;
        let action=this.state.action;
        
        let save=true;
        let dato="";
        let self = this;        
        
        let check = ['item_id','almacen_id','fisico','justificacion'];

        for(let i in check) {

            let key = check[i];

            let value = inventarioFisico[key];
            dato=key;

            if(value == '' || value == null){
                save = false;
                break;
            }
                
        }       
   	

   		console.log(inventarioFisico)
        // impuesto=this.objeto_mayusculas(impuesto);
       
        if(save){

            api().post(`/inventarioFisico/validar`, inventarioFisico)
            .then(function(response)
            {
              console.log(response.data)
              if(response.data.validacion || response.data.id == inventarioFisico.value){
  	        	  self.props[action](inventarioFisico, (data) => {
  	                swal({
  	                    title: 'Inventario Fisico',
  	                    text: 'Registro Guardado correctamente!',
  	                    type: 'success',
  	                    // showCancelButton: true,
  	                    // confirmButtonColor: '#3085d6',
  	                    // cancelButtonColor: '#d33',
  	                    confirmButtonText: 'Continue!'
  	                }).then((result) => {
  	                    if (result.value) {
  	                        self.props.toggle();
  	                        self.resetModal();
  	                    }
  	                })
  	          	}); 
              }else{
                swal("Oops..", "El producto ya se encuentra en el inventario fisico ");
              } 
  	        });
          }
            else{
	        	swal("Oops..", "Verifique la informacion ");
	        }
        }
    

    render()
    {

        let {inventarioFisico}=this.state;
  		  let { no_editar }= this.state;

  		let editar= null


  		if(inventarioFisico.almacen_codigo !== '')
  			editar =false
  		else
  			editar = true
      
      if(no_editar){
        editar = true
      }

        return(

           <Modal isOpen={this.props.open} toggle={this.props.toggle} className="default modal-lg modal_cliente">
                <form >
                <ModalHeader toggle={this.props.toggle}>{this.props.title}</ModalHeader>
                <ModalBody>
                   <div className="row justify-content-center">
                   		<div className="col-md-5"> 
	                        <div className="form-group">
	                            <label className="-block">Almacen:</label>
	                            <Input
	                            placeholder=""
	                            type="text"
	                            name="almacen_codigo"
	                            value={inventarioFisico.almacen_codigo}
	                            onChange={ this.handleInputChange}
	                            onBlur={this.handleClose}
	                            className="input_button_sm"
	                            disabled={no_editar}
	                           
	                            />
	                            <Button onClick={ (button) => { this.toggle_modal(25,"Almacenes","almacen_id") } } disabled={no_editar}>...</Button>
	                            <label className="mt-2">
    	                    			{inventarioFisico.almacen_nombre}
    	                    		</label>
	                        </div>
	                    </div>
                   		<div className="col-md-5"> 
                            <div className="form-group">
                                <label className="-block">Producto:</label>
                                <Input
                                placeholder=""
                                type="text"
                                name="item_codigo"
                                value={inventarioFisico.item_codigo}
                                onChange={ this.handleInputChange}
                                onBlur={this.handleClose}
                                className="input_button_sm"
                                disabled={editar}
                               
                                />
                                <Button onClick={ (button) => { this.toggle_modal(29,"Productos","item_id") } } disabled={no_editar}>...</Button>
                                <label className="mt-2">
      	                    			{inventarioFisico.item_nombre}{inventarioFisico.label}
      	                    		</label>
                            </div>
                        </div>
                   </div>
                   <div className="row justify-content-center">
                   		<div className="col-4">
                   			<div className="form-group">
                   				<label>Fisico</label>
                   				<Input
                   					placeholder=""
                   					type="number"
                   					name="fisico"
                   					value={inventarioFisico.fisico}
                   					onChange={this.handleInputChange}

                   				/>
                   			</div>
                   		</div>
                   		<div className="col-4">
                   			<div className="form-group">
                   				<label>Existencia</label>
                   				<Input
                   					placeholder=""
                   					type="number"
                   					name="existencia"
                   					value={inventarioFisico.existencia}
                   					onChange={this.handleInputChange}
                   					readOnly
                   				/>
                   			</div>
                   		</div>
                   </div>
                    <div className="row justify-content-center">
                      <div className="col-8">
                        <div className="form-group">
                          <label>Justificación</label>
                          <Input
                            placeholder=""
                            rows={5}                                                        
                            type="textarea"
                            maxLength={499}
                            name="justificacion"
                            value={inventarioFisico.justificacion}
                            onChange={this.handleInputChange}

                          />
                        </div>
                      </div>
                   </div>

                </ModalBody>
                <ModalFooter>
                    {
                        this.props.inventarioFisico.saving ?
                        <SubmitLoad /> : 
                        <div>
                            <Button color="primary" type="submit"  onClick={this.handleSubmit} >
                                <IconSave />&nbsp;Guardar
                            </Button>{' '}
                            <Button color="secondary" onClick={this.props.toggle}>
                                Cancel
                            </Button>
                        </div>
                    }
                </ModalFooter>
                { this.state.modal&&
	                <ModalTablas
	                    open={this.state.modal}
	                    toggle={this.toggle_modal}                  
	                    titulo={this.state.titulo}
	                    catalogo={this.state.tabla_modal}
	                    retorno={this.retorno}
	                    campo={this.state.campo_modal}
                      almacen={this.state.inventarioFisico.almacen_id}
	                />
	            }
                </form>
            </Modal>
        );
    }
}

function mapStateToProps(state, ownProps) {
    return {
        inventarioFisico : state.inventarioFisico,
        auth:state.auth
    }
};

export default connect(mapStateToProps, actions)(InventarioFisicoModal)


// WEBPACK FOOTER //
// ./src/views/inventarioFisico/inventarioFisicoModal.js